module.exports = __webpack_public_path__ + "static/mainImage-45c312ea4d75b06210fa601752b09f1e.jpg";